import React, { useState } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { Stack } from '@mui/material/';
import { InputFile } from '../conflict-mineral/InputFile';
import { Template } from '../conflict-mineral/Template'
import { Form, Button, Col } from '@deere/ux.uxframe-react'
import { validateSupplierNumbersByChunk } from '../../services/external.service';
import { validateSupplierPart, validateDuplicates, validateNonDeereDuplicates, createSurveyAssignments, createNonDeereAssignments, validateEWDCDuplicates, createEWDCAssignments } from '../../utils/fileUtil'
import { PART_SUPPLIER_NUMBER_COLUMN, PART_COLUMN, PART_DESCRIPTION_COLUMN, PART_HSCODE_COLUMN, PART_SECTION_COLUMN, TEMPLATE_NAME, NON_DEERE_SUPPLIER_EMAIL_COLUMN, NON_DEERE_COMPANY_EMAIL_COLUMN, NON_DEERE_SUPPLIER_NUMBER_COLUMN,  NON_DEERE_SUPPLIER_NAME_COLUMN, NON_DEERE_PART_NUMBER_COLUMN, NON_DEERE_PART_DESCRIPTION_COLUMN, DATA_VALIDATE_SUCCESS, EWDC, PART_FIRST_NAME_COLUMN, PART_LAST_NAME_COLUMN, PART_RACF_COLUMN } from '../../utils/surveyLiterals'
import { ERR_SUPPLIER_REQUIRED, ERR_COLUMNS_REQUIRED, ERR_RECORDS_REQUIRED, NON_DEERE_ERR_RECORDS_REQUIRED, ERR_ROW_DUPLICATED, ERR_REMOVE_EMPTY_LINES, ERR_SUP_NUM_INVALID, ERR_ALL_SUP_INVALID, ERR_SECTION_VALUE } from "../../utils/errorLiterals";

export const SurveyPartCard = ({ loading, setLoading, setErrorMessage, setSuccessMessage, campaign, setValidated, setDisableSubmit, authState, userInfo, onChange, isEnable, partSections, partTemplateColumns }) => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);

    const validateSupplierNumbers = () => {
        setLoading(true);
        setSuccessMessage('');
        setErrorMessage('');
        if (!Array.isArray(data) || data.length <= 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(ERR_SUPPLIER_REQUIRED);
            setLoading(false);
            return;
        }
        const objColumns = campaign.isNonDeere ? partTemplateColumns.nonDeere[0] : partTemplateColumns.deere[0];
        const isError = Object.keys(objColumns).some((key) => !columns.some((col) => col.headerName === key));
        if (!Array.isArray(columns) || isError) {
          setErrorMessage(`${ERR_COLUMNS_REQUIRED}: ${Object.keys(objColumns).join(", ")}`);
          setValidated(true);
          setDisableSubmit(true);
          setLoading(false);
          return;
        }    
        const duplicates = campaign.code === EWDC ? validateEWDCDuplicates(data) : campaign.isNonDeere? validateNonDeereDuplicates(data, NON_DEERE_SUPPLIER_NUMBER_COLUMN, NON_DEERE_PART_NUMBER_COLUMN):validateDuplicates(data,PART_SUPPLIER_NUMBER_COLUMN,PART_COLUMN)
        const colsToValidate = campaign.code === EWDC ? [PART_SUPPLIER_NUMBER_COLUMN, PART_FIRST_NAME_COLUMN, PART_LAST_NAME_COLUMN, PART_RACF_COLUMN] :[PART_SUPPLIER_NUMBER_COLUMN,PART_COLUMN,PART_DESCRIPTION_COLUMN];
        const nonDeereColsToValidate = [NON_DEERE_SUPPLIER_EMAIL_COLUMN, NON_DEERE_COMPANY_EMAIL_COLUMN, NON_DEERE_SUPPLIER_NUMBER_COLUMN,  NON_DEERE_SUPPLIER_NAME_COLUMN, NON_DEERE_PART_NUMBER_COLUMN, NON_DEERE_PART_DESCRIPTION_COLUMN]
        if (partSections.length > 1) {
            colsToValidate.push(PART_SECTION_COLUMN);
            nonDeereColsToValidate.push(PART_SECTION_COLUMN);
        }
        const validSupplierPart = validateSupplierPart(data,campaign.isNonDeere? nonDeereColsToValidate:colsToValidate);
        if (validSupplierPart.length > 0) {
            setValidated(true);
            setDisableSubmit(true);
            if(!campaign.isNonDeere){
                setErrorMessage(`${ERR_RECORDS_REQUIRED} : ${validSupplierPart.map(element => element)}`);
            }else{
                setErrorMessage(`${NON_DEERE_ERR_RECORDS_REQUIRED} : ${validSupplierPart.map(element => element)}`)
            }
            setLoading(false);
            return;
        }
        if (duplicates.length > 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_ROW_DUPLICATED} : ${duplicates.map(element => element)}`);
            setLoading(false);
            return;
        }
        if (partSections.length > 1) {
            const isSectionError = data.some(d => {
                const sections = d[PART_SECTION_COLUMN]?.split('|').map(s => s.trim()) || [];
                const isFound =  sections.some(section => !partSections.includes(section));
                return isFound;
            });
            if (isSectionError) {
                setValidated(true);
                setDisableSubmit(true);
                setErrorMessage(`${ERR_SECTION_VALUE} - ${partSections.join(", ")}`);
                setLoading(false);
                return;
            }
        }
        if(campaign.isNonDeere){
            setValidated(false);
            setDisableSubmit(false);
            campaign.assignments = createNonDeereAssignments(data, userInfo);
            setSuccessMessage(DATA_VALIDATE_SUCCESS);
            setLoading(false);
        }else{
            const suppliers = data.map(element => element[PART_SUPPLIER_NUMBER_COLUMN]);
            if (Array.isArray(suppliers) && suppliers.length > 0) {
                const uniqueSuppliers = Array.from(new Set(suppliers));
                const formattedSuppliers = uniqueSuppliers.map(s => { return s !== null && s !== undefined ? s.toString().trim().padStart(10, '0') : "" })
                validateSupplierNumbersByChunk(authState.accessToken.accessToken, formattedSuppliers).then(sup => {
                    if (sup && sup.length > 0) {
                        setValidated(true);
                        setDisableSubmit(true);
                        let errMsg = sup[0].length > 0 ? sup[0].join(', ') : sup[0]
                        if (errMsg === ', ' || errMsg.length === 0) {
                            setErrorMessage(ERR_REMOVE_EMPTY_LINES)
                        } else {
                            setErrorMessage(`${ERR_SUP_NUM_INVALID}: ${errMsg}`)
                        }
                    } else {
                        setValidated(false);
                        setDisableSubmit(false);
                        campaign.assignments = campaign.code === EWDC ? createEWDCAssignments(data, userInfo) :campaign.isNonDeere ? createNonDeereAssignments(data, userInfo) : createSurveyAssignments(data, userInfo);
                        setSuccessMessage(ERR_ALL_SUP_INVALID);
                    }
                    setLoading(false);
                });
            }
        }
    }

    return (
        <>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label" style={{ marginRight: "10px" }}>Would you like to enable this campaign to retrieve historical data for the parts being added?</Form.Label>
                    <Form.Check type="radio" value='true' inline label='Yes' name="fetchHistoricalData" disabled={loading || !isEnable} onChange={onChange} checked={campaign.fetchHistoricalData} />
                    <Form.Check type="radio" value='false' inline label='No' name="fetchHistoricalData" disabled={loading || !isEnable} onChange={onChange} checked={!campaign.fetchHistoricalData} />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Supplier - Part</Form.Label>
                            <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                                <InputFile setData={setData} setColDefs={setColumns} loading={loading} />
                            </Stack>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Supplier Part Template</Form.Label>
                            <Form.Row>
                                 <Template csvData={campaign.isNonDeere ? partTemplateColumns.nonDeere : partTemplateColumns.deere} fileName={TEMPLATE_NAME} />
                            </Form.Row>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <DataGrid autoHeight={true} rows={data} columns={columns} disableColumnMenu={true} rowsPerPageOptions={[]} pageSize={10} />
                    </Form.Row>
                </Form.Group>
            </Form.Row>
            <Form.Row className="d-block mb-4">
                <Form.Group as={Col} className="align-right" >
                    <Button variant="secondary" className="float-right" onClick={validateSupplierNumbers} disabled={loading}>
                        {campaign.isNonDeere ? 'Validate Data' : 'Validate Supplier Numbers'}
                    </Button>
                </Form.Group>
            </Form.Row>
        </>
    )
}
